/* RunAction.js */

"use strict";

const RunScreenComponent = require("./RunScreenComponent");

class RunAction {
    constructor(logger, gameEditor, modalUserFeedback, DeviceEntity, OsUpgradePlan, userSession, activityMonitor, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._userSession = userSession;
        this._deviceEntity = DeviceEntity;
        this._osPlan = OsUpgradePlan;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activityMonitor = activityMonitor;
        this.run = this.run.bind(this);
    }

    run() {
        let runScreenComponent = new RunScreenComponent(
            this._logger,
            this._gameEditor,
            this._osPlan,
            this._deviceEntity,
            this._activeView,
            this._modalUserFeedback,
            this._userSession
        );
        //const ActivityMonitor = this._activityMonitor;

        return this._modalUserFeedback.displayCustom(runScreenComponent, { dontHide: false }).catch((err) => {
            if (err && err.userRejected) {
                this._logger.warn({ error: err }, "PlanRunAction.run() - User Canceled");
                return;
            } else {
                this._logger.warn({ error: err }, "PlanRunAction.run() - Error");
                return this._modalUserFeedback.displayError(err);
            }
        });
    }
}

module.exports = RunAction;

RunAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Device",
    "$teve.entities.OsUpgradePlan",
    "$teve.userSession",
    "$teve.activityMonitor",
    "gameEditor.activeView"
];

RunAction.$displayDetails = {
    type: "Action",
    name: "ConfigureAuditAction",
    icon: "osmanager.run_os_plans",
    shown: true,
    title: "Run OS Plan",
    order: 1
};
